const divTableTitleMat = {
  option1: 'INACTIVAR SELECCIONADOS',
  option2: 'PRINT QRCODES',
  option3: 'ENVIAR A MANTENIMIENTO',
  option4: 'RETORNO DE MANTENIMIENTO',
  option5: 'REACTIVAR SELECCIONADOS',
  option6: 'ELIMINAR SELECCIONADOS',
  option7: 'CREAR SERVICIO EM MASSA',
  option8: 'SERVICIOS CON ANEXOS (.ZIP)',
  tooltipBlockQRCode: 'Cuando los servicios solo se pueden hacer a través de QRCode en la APP,la impresión de QRCode solo está permitida para admins.',
};

export default divTableTitleMat;
